package meineglasfaser.frontend.www.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.frontend.www.components.sections.ShopFooter
import meineglasfaser.frontend.www.components.sections.ShopHeader
import org.jetbrains.compose.web.dom.Main

const val CONTAINER_CLASS = "container-xl"

@Layout
@Composable
fun ShopLayout(content: @Composable () -> Unit) {
    ShopHeader()
    Main(attrs = { classes(CONTAINER_CLASS) }) {
        content()
    }
    ShopFooter()
}
